"use client";
import React from "react";
import { ReserveState } from "./types";

export const ReserveContext = React.createContext<ReserveState | undefined>(
  undefined
);

export const useReserve = () => {
  const context = React.useContext(ReserveContext);
  if (context === undefined) {
    throw new Error("useReserve must be used within a ReserveProvider");
  }
  return context;
};
